import {getSensitiveStrings} from './sensitiveStringsActions'

const MASKING_CHAR = '*'

const protectObjectFromSensitiveData = <T>(unsafeObject: T): T => {
  const jsonEncodedUnsafeObject = JSON.stringify(unsafeObject)
  const sensitiveStrings = getSensitiveStrings()

  const cleanedString = sensitiveStrings.reduce(
    (currentString, sensitiveString) =>
      currentString.replaceAll(sensitiveString, MASKING_CHAR.repeat(sensitiveString.length)),
    jsonEncodedUnsafeObject
  )

  return JSON.parse(cleanedString)
}

export function sensitiveDataCleanerMiddleware<T extends Record<string, unknown>>(log: T): T {
  const result = protectObjectFromSensitiveData(log)

  return result
}
